module.exports = __webpack_public_path__ + "fc0f5048165f4b2cc1df0889860fbd54.svg";